export const FILE_MAX_SIZE = 16777216;